module.exports = __webpack_public_path__ + "img/lotteryGoodGiftBanner.25d1e6ac.png";